import { on } from 'delegated-events'
import debounce from 'lodash/debounce'

const header = document.querySelector('.site-header')

const fn = {
  init: () => {
    document.documentElement.classList.remove('is-init')
    fn.bindEvents()
  },

  bindEvents: () => {
    window.addEventListener('resize', debounce(fn.handleResize, 250))
    on('click', '.site-nav-trigger', fn.toggleNav)

    const observer = new IntersectionObserver(
      ([e]) => header.classList.toggle('is-stuck', e.intersectionRatio < 1),
      {
        threshold: [1],
      }
    )

    observer.observe(document.querySelector('.scroll-pixel'))
  },

  handleResize: () => {
    if (window.matchMedia('(min-width: 768px)').matches) {
      document.documentElement.classList.remove('js-nav-active')
    }
  },

  toggleNav: () => {
    document.documentElement.classList.toggle('js-nav-active')
  },
}

export default {
  can: () => document.contains(header),
  run: fn.init,
}
